import Config from "./Config"
import SchoolNames from "./SchoolNames"
export default {
    Config: Config,
    SchoolNames: SchoolNames
}

